export default __webpack_public_path__ + "static/media/screen7.23e67e12.svg";